export default __webpack_public_path__ + "static/media/accounts.89454273.svg";